import { ReactElement } from 'react';

import { DemoNoticeUsingDemoUserBarGroup } from '@dreryk/demo-variant-frontend';
import { UserBar, UserBarGroup, UserBarGroupLinkWrap } from '@dreryk/react-components';

import { EmergencyNotificationUserBarGroup } from '~libs.desktop.emergency-notification';

import { ConfidentialityNotificationsBadge } from '../features/confidentialityNotificationsBadge/ConfidentialityNotificationsBadge';

import { ExperimentalMonitUserBarGroup } from './ExperimentalMonitUserBarGroup';
import { PayInvoicesUserBarGroup } from './PayInvoicesUserBarGroup';
import { SessionRemainingTimerUserBarGroup } from './SessionRemainingTimerUserBarGroup';
import { ThemeToggle } from './ThemeToggle';
import { UserDropdown } from './UserDropdown';

export const MainToolbar = (): ReactElement => {
   return (
      <UserBar>
         <DemoNoticeUsingDemoUserBarGroup />
         <ExperimentalMonitUserBarGroup />
         <PayInvoicesUserBarGroup />
         <SessionRemainingTimerUserBarGroup />
         <UserBarGroup testId={'themeToggle'}>
            <UserBarGroupLinkWrap testId={'themeToggle'}>
               <ThemeToggle />
            </UserBarGroupLinkWrap>
         </UserBarGroup>

         <EmergencyNotificationUserBarGroup />

         <UserBarGroup testId={'userDropdown'}>
            <UserBarGroupLinkWrap testId={'userDropdown'}>
               <UserDropdown />
            </UserBarGroupLinkWrap>
         </UserBarGroup>

         <ConfidentialityNotificationsBadge />
      </UserBar>
   );
};
